import React, { useState } from 'react';
import "./Placeorder.css";
import Swal from 'sweetalert2';

const PlacePopUp = ({ props, open, onClose, items, calculateItemTotal, calculateCartTotal }) => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [landmark, setLandmark] = useState('');
  const [instructions, setInstructions] = useState('');
  const [cardHolderName, setCardHolderName] = useState('');
  const [cardNumber, setCardNumber] = useState('');

  // console.log(items);

  const handlePlaceorder = () => {
    // Perform form validation check
    if (fullName && email && phoneNumber && address && city && state && cardHolderName && cardNumber) {
      const formData = {
        fullName,
        email,
        phoneNumber,
        address,
        city,
        state,
        landmark,
        instructions,
        cardHolderName,
        cardNumber
      };

      const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'success',
        title: 'Thank you for ordering!!'
      });

      // Display the form data in an alert
      alert(JSON.stringify(formData));
    } 
  }

  return (
    <div>
      {open ? (
        <div className='overlayy'>
          <div className='placemodalContainer'>
            <div id="ui-container" className="uiContainer">
              <form className="formContainer">
                <div className="billingInfo">
                  <h2 className="sectionTitle">Billing Information</h2>
                  <input
                    className="inputField"
                    type="text"
                    placeholder="Enter your full name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    required
                  />
                  <input
                    className="inputField"
                    type="email"
                    placeholder="Please enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <div className="inputGroup">
                    <input
                      className="inputFieldNumber"
                      type="tel"
                      placeholder="Enter your phone number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      required
                    />
                    <input
                      className="inputFieldaddress"
                      type="text"
                      placeholder="Enter your complete address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      required
                    />
                  </div>
                  <div className="inputGroup">
                    <input
                      className="inputFieldCity"
                      type="text"
                      placeholder="Enter your city"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                    <input
                      className="inputFieldState"
                      type="text"
                      placeholder="Enter your state"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      required
                    />
                  </div>
                  <input
                    className="inputField"
                    type="text"
                    placeholder="Nearest Landmark"
                    value={landmark}
                    onChange={(e) => setLandmark(e.target.value)}
                  />
                  <input
                    className="inputField"
                    type="text"
                    placeholder="Enter any instructions or note to rider"
                    value={instructions}
                    onChange={(e) => setInstructions(e.target.value)}
                  />
                </div>
                <div className="paymentInfo">
                  <h2 className="sectionTitle">Payment Information</h2>
                  <input
                    className="inputField"
                    type="text"
                    placeholder="Card Holder Name"
                    value={cardHolderName}
                    onChange={(e) => setCardHolderName(e.target.value)}
                    required
                  />
                  <input
                    className="inputField"
                    type="text"
                    placeholder="Card Number"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                    required
                  />
                </div>
                <div className='buttonsDiv'>
                  <button className="submitButton" onClick={handlePlaceorder}>Place Order</button>
                  <div className="wrapper">
                    <div className="link_wrapper">
                      <div className='gobackbutton' onClick={onClose}>Continue Shopping</div>
                      <div className="backicon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 268.832 268.832">
                          <path d="M265.17 125.577l-80-80c-4.88-4.88-12.796-4.88-17.677 0-4.882 4.882-4.882 12.796 0 17.678l58.66 58.66H12.5c-6.903 0-12.5 5.598-12.5 12.5 0 6.903 5.597 12.5 12.5 12.5h213.654l-58.66 58.662c-4.88 4.882-4.88 12.796 0 17.678 2.44 2.44 5.64 3.66 8.84 3.66s6.398-1.22 8.84-3.66l79.997-80c4.883-4.882 4.883-12.796 0-17.678z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div className="orderSummary">
                <h2 className="sectionTitle">Order Summary</h2>
                {items.map((item, index) => (
                  <React.Fragment key={index}>
                    <div className="productInfo">
                      <div className="productDetails">
                        <div>
                          <h4 className="productName">{item.name} ( {item.option.name} ) x{item.quantity}</h4>
                          <p className="productPrice">Price: Rs.{item.price}</p>
                          <h5>Add-Ons:</h5>
                          {item.toppings.length === 0 ? (
                            <p> - </p>
                          ) : (
                            item.toppings.map((topping) => (
                              <p className='productToppings' key={topping.id}>{topping.name} x{topping.quantity}</p>
                            ))
                          )}
                          <p>Subtotal:</p>
                          <p className="totalsInfoValue">Rs. {calculateItemTotal(item)}</p>
                        </div>
                        <div className="productImageContainer"><img className="productImage" src={item.image} alt='' /></div>
                      </div>
                    </div>
                    <hr className="placedivider" />
                  </React.Fragment>
                ))}
                <div className="totalsInfo">
                  <p>Tax:</p>
                  <p className="totalsInfoValue">Rs.</p>
                  <p className="totalsInfoLabel">Total: </p>
                  <p className="totalsInfoValue">Rs.{calculateCartTotal()}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

PlacePopUp.defaultProps = {
  Tax: 20,
};

export default PlacePopUp;
